import { ReactElement } from 'react'
import { useFeatureAvailable } from '../../../FeatureFlags'
import { BulkContactExportMonitoring as FloBCEM } from './flo'
import { BulkContactExportMonitoring as GridBCEM } from './grid'

export function BulkContactExportMonitoring(): ReactElement {

  // The "cher.enableFloBulkContactExportMonitoringPage" flag is intended to be temporary
  // Eventually the Flo vs Grid grid routing will be determined solely on the "flo-bce" flag
  const enableFloBCEMUI = useFeatureAvailable('cher.enableFloBulkContactExportMonitoringPage')
  const enableFloBCEM = useFeatureAvailable('flo-bce')

  return enableFloBCEM && enableFloBCEMUI
    ? <FloBCEM />
    : <GridBCEM />
}
